<template>
  <div>
    <Forms ref="frmSinisterTyping"
        :title="$lang.Sinister.Typing.TitleForm"
        :showHelp="true"
        :showClearButton="false"
        :showSearchButton="false">
      <Alerts ref="alert"/>
      <SinisterHeader ref="SinisterHeader"/>
      <div class="form-group row"><div class="col-md-12"><hr></div></div>
      <div class="form-group row">
        <div class="col-md-12 intermediate-bar"><i class="fa fa-dollar"></i>&nbsp; VALORES </div>
      </div>
      <div class="form-group row">
        <div class="col-md-3">
          <label for="txtBodywork">Funilaria:</label>
          <div class="input-group">
            <span class="input-group-addon"><i class="fa fa-dollar"></i></span>
            <money name="txtBodywork"
                class="form-control form-control-10 text-right"
                v-bind="moneyFormat"
                :placeholder="'0,00'"
                prefix="R$ "
                v-model="form.bodywork.value"
                :size="form.bodywork.maxlength"
                :required="form.bodywork.required"
                :state="form.bodywork.state"
                :disabled="isCompleted">
            </money>
          </div>
        </div>
        <div class="col-md-3">
          <label for="txtRepair">Reparação:</label>
          <div class="input-group">
            <span class="input-group-addon"><i class="fa fa-dollar"></i></span>
            <money name="txtRepair" class="form-control form-control-10 text-right"
              v-bind="moneyFormat"
              v-model="form.repair.value"
              :placeholder="'0,00'"
              prefix="R$ "
              :size="form.repair.maxlength"
              :required="form.repair.required"
              :state="form.repair.state"
              :disabled="isCompleted">
            </money>
          </div>
        </div>
        <div class="col-md-3">
          <label for="txtPainting">Pintura:</label>
          <div class="input-group">
            <span class="input-group-addon"><i class="fa fa-dollar"></i></span>
            <money name="txtPainting" class="form-control form-control-10 text-right"
              v-bind="moneyFormat"
              v-model="form.painting.value"
              :placeholder="'0,00'"
              prefix="R$ "
              :size="form.painting.maxlength"
              :required="form.painting.required"
              :state="form.painting.state"
              :disabled="isCompleted">
            </money>
          </div>
        </div>
        <div class="col-md-3">
          <label for="txtTapestry">Tapeçaria/Vidraçaria:</label>
          <div class="input-group">
            <span class="input-group-addon"><i class="fa fa-dollar"></i></span>
            <money name="txtPainting" class="form-control form-control-10 text-right"
              v-bind="moneyFormat"
              :placeholder="'0,00'"
              prefix="R$ "
              v-model="form.tapestry.value"
              :size="form.tapestry.maxlength"
              :required="form.tapestry.required"
              :state="form.tapestry.state"
              :disabled="isCompleted">
            </money>
          </div>
        </div>
      </div>
      <div class="form-group row">
        <div class="col-md-3">
          <label for="txtElectrical">Elétrica:</label>
          <div class="input-group">
            <span class="input-group-addon"><i class="fa fa-dollar"></i></span>
            <money name="txtElectrical" class="form-control form-control-10 text-right"
              v-bind="moneyFormat"
              :placeholder="'0,00'"
              prefix="R$ "
              v-model="form.electrical.value"
              :size="form.electrical.maxlength"
              :required="form.electrical.required"
              :state="form.electrical.state"
              :disabled="isCompleted">
            </money>
          </div>
        </div>
        <div class="col-md-3">
          <label for="txtMechanical">Mecânica:</label>
          <div class="input-group">
            <span class="input-group-addon"><i class="fa fa-dollar"></i></span>
            <money name="txtMechanical" class="form-control form-control-10 text-right"
                          v-bind="moneyFormat"
                          :placeholder="'0,00'"
                          prefix="R$ "
                          v-model="form.mechanical.value"
                          :size="form.mechanical.maxlength"
                          :required="form.mechanical.required"
                          :state="form.mechanical.state"
                          :disabled="isCompleted">
            </money>
          </div>
        </div>
        <div class="col-md-3">
          <label for="txtThird">Terceiros:</label>
          <div class="input-group">
            <span class="input-group-addon"><i class="fa fa-dollar"></i></span>
            <money name="txtThird" class="form-control form-control-10 text-right"
                          v-bind="moneyFormat"
                          :placeholder="'0,00'"
                          prefix="R$ "
                          v-model="form.third.value"
                          :size="form.third.maxlength"
                          :required="form.third.required"
                          :state="form.third.state"
                          :disabled="isCompleted">
            </money>
          </div>
        </div>
        <div class="col-md-3">
          <label for="txtWithSuppliedParts">Total Peças com fornecimento:</label>
          <div class="input-group">
            <span class="input-group-addon"><i class="fa fa-dollar"></i></span>
            <money name="txtWithSuppliedParts" class="form-control form-control-10 text-right"
                          v-bind="moneyFormat"
                          :placeholder="'0,00'"
                          prefix="R$ "
                          v-model="form.withSuppliedParts.value"
                          :size="form.withSuppliedParts.maxlength"
                          :required="form.withSuppliedParts.required"
                          :state="form.withSuppliedParts.state"
                          :disabled="isCompleted">
            </money>
          </div>
        </div>
      </div>
      <div class="form-group row">
        <div class="col-md-3">
          <label for="txtWithoutSuppliedParts">Total Peças sem fornecimento:</label>
          <div class="input-group">
            <span class="input-group-addon"><i class="fa fa-dollar"></i></span>
            <money name="txtWithoutSuppliedParts" class="form-control form-control-10 text-right"
                          v-bind="moneyFormat"
                          :placeholder="'0,00'"
                          prefix="R$ "
                          v-model="form.withoutSuppliedParts.value"
                          :size="form.withoutSuppliedParts.maxlength"
                          :required="form.withoutSuppliedParts.required"
                          :state="form.withoutSuppliedParts.state"
                          :disabled="isCompleted">
            </money>
          </div>
        </div>
        <div class="col-md-3">
          <label for="txtFranchise">Franquia:</label>
          <div class="input-group">
            <span class="input-group-addon"><i class="fa fa-dollar"></i></span>
            <money name="txtFranchise" class="form-control form-control-10 text-right text-danger"
                          v-bind="moneyFormat"
                          :placeholder="'0,00'"
                          prefix="R$ "
                          v-model="form.franchise.value"
                          :size="form.franchise.maxlength"
                          :required="form.franchise.required"
                          :state="form.franchise.state"
                          :disabled="isCompleted">
            </money>
          </div>
        </div>
        <div class="col-md-3">
          <label for="txtCarDamage">Avarias:</label>
          <div class="input-group">
            <span class="input-group-addon"><i class="fa fa-dollar"></i></span>
            <money name="txtCarDamage" class="form-control form-control-10 text-right text-danger"
                          v-bind="moneyFormat"
                          :placeholder="'0,00'"
                          prefix="R$ "
                          v-model="form.carDamage.value"
                          :size="form.carDamage.maxlength"
                          :required="form.carDamage.required"
                          :state="form.carDamage.state"
                          :disabled="isCompleted">
            </money>
          </div>
        </div>
        <div class="col-md-3">
          <label for="txtBudgeted" style="font-weight:bold;font-size:14px;">Total Orçado:</label>
          <div class="input-group">
            <span class="input-group-addon"><i class="fa fa-dollar"></i></span>
            <money name="txtBudgeted" class="form-control form-control-10 text-right"
                          style="font-weight:bold;font-size:15px;"
                          v-bind="moneyFormat"
                          :placeholder="'0,00'"
                          prefix="R$ "
                          :value="totalBudgeted"
                          :size="form.budgeted.maxlength"
                          :required="form.budgeted.required"
                          :state="form.budgeted.state"
                          :disabled="isCompleted">
            </money>
          </div>
        </div>
      </div>

      <div class="form-group row" pt-4><div class="col-md-12"><hr></div></div>

      <div class="form-group row">
        <div class="col-md-2">
          <label for="txtActionDateTyping"><small v-show="form.surveyDate.required"  class="text-danger">*</small> {{$lang.Sinister.Typing.SurveyDate}}:</label>
          <div class="input-group">
            <datepicker name="txtActionDateTyping" v-model="form.surveyDate.value"
                        :format="'dd/MM/yyyy'"
                        :language="ptBR"
                        :placeholder="$lang.Common.DatePlaceholder"
                        :clear-button="false"
                        :clear-button-icon="'fa fa-close'"
                        :calendar-button="false"
                        :calendar-button-icon="'fa fa-calendar'"
                        :bootstrap-styling="true"
                        :full-month-name="true"
                        :use-utc="true"
                        :disabled="isCompleted"/>
          </div>
        </div>
        <div class="col-md-2">
          <label for="cbxTypeConclusion"><small class="text-danger">*</small> Tipo de Conclusão</label>
          <div class="input-group">
            <b-form-select v-model="form.typeConclusionID.value"
                          :options="[]"
                          :state="form.typeConclusionID.state"
                          class="mb-3"
                          name="cbxTypeConclusion"
                          :disabled="isCompleted"
                          @input="onChangeTypeConclusion">
              <template slot="first">
                <!-- this slot appears above the options from 'options' prop -->
                <option value="">{{$lang.Common.PlaceholderSelect}}</option>
              </template>
              <option :value="1">Autorizado</option>
              <option :value="2">Não Autorizado</option>
              <option :value="3">Frustrada</option>
              <option :value="5">Não Acordo</option>
              <option :value="6">Cancelado</option>
              <option :value="8">Atualizado</option>
              <option :value="4" disabled>Outros</option>
            </b-form-select>
          </div>
        </div>
        <div class="col-md-2" v-show="form.typeConclusionID.value === 3 || form.typeConclusionID.value === 6">
          <label for="cbxReasonFrustration"><small class="text-danger">*</small> Motivo da Frustração/Cancelamento</label>
          <div class="input-group">
              <b-form-select v-model="form.reasonFrustration.value"
                            :options="form.reasonFrustration.options"
                            :state="form.reasonFrustration.state"
                            class="mb-3"
                            name="cbxReasonFrustration"
                            :disabled="isCompleted">
                <template slot="first">
                  <!-- this slot appears above the options from 'options' prop -->
                  <option value="">{{$lang.Common.PlaceholderSelect}}</option>
                </template>
                <option :value="1">Pedido Indevido</option>
                <option :value="2">Veículo Ausente</option>
                <option :value="3">Orçamento em elaboração</option>
                <option :value="4">Responsável Ausente</option>
                <option :value="5">Realizado pela CIA</option>
              </b-form-select>
          </div>
        </div>
        <div class="col-md-6" v-show="form.typeConclusionID.value == 4">
          <label for="txtTypingSpecify"><small class="text-danger">*</small> Especifique</label>
          <b-form-textarea name="txtTypingSpecify"
                          v-model="form.description.value"
                          :placeholder="$lang.Sinister.Details.PlaceholderSeem"
                          :rows="form.description.rows"
                          :size="form.description.maxlength"
                          :noResize="form.description.noResize"
                          :disabled="isCompleted"/>
        </div>
        <div class="col-md-2" v-show="form.typeConclusionID.value != 3 && form.typeConclusionID.value != 6">
          <label for="cbxtypeLoss"><small class="text-danger">*</small> Tipo de Perda</label>
          <div class="input-group">
            <b-form-select v-model="form.lossTypeID.value"
                          :options="[]"
                          :state="form.lossTypeID.state"
                          class="mb-3"
                          name="cbxtypeLoss"
                          :disabled="isCompleted"
                          @input="onChangeLossType">
              <template slot="first">
                <!-- this slot appears above the options from 'options' prop -->
                <option value="">{{$lang.Common.PlaceholderSelect}}</option>
              </template>
              <option :value="1">PP - Perda Parcial</option>
              <option :value="2">II - Indenização Integral</option>
            </b-form-select>
          </div>
        </div>
        <div class="col-md-4" v-show="form.lossTypeID.value == 2 && (form.typeConclusionID.value != 3 || form.typeConclusionID.value != 6 )">
          <label for="cbxEngineNumber"><small class="text-danger">*</small> Tem foto do Número do Motor?</label>
          <div class="input-group">
            <b-form-select v-model="form.engineNumber.value"
                          :options="form.engineNumber.options"
                          :state="form.engineNumber.state"
                          class="mb-3"
                          name="cbxEngineNumber"
                          :disabled="isCompleted">
              <template slot="first">
                <!-- this slot appears above the options from 'options' prop -->
                <option :value="null">{{$lang.Common.PlaceholderSelect}}</option>
              </template>
              <option :value="1">Sim</option>
              <option :value="0">Não</option>
            </b-form-select>
          </div>
        </div>
      </div>

      <div class="form-group row">
        <div class="col-md-12">
          <label for="txtComments"> {{$lang.Sinister.Typing.Comments}}:</label>
              <b-form-textarea id="txtComments"
                              name="txtComments"
                              v-model="form.comments.value"
                              :rows="form.comments.rows"
                              :size="form.comments.maxlength"
                              :disabled="isCompleted"/>
        </div>
      </div>

      <div class="form-group row pb-3" v-if="hasRole(this.roles.RW_REG_TABDIGITATION)">
        <div class="col-md-12 text-left force-border-bottom pl-3">
          <button type="button" class="btn btn-third btn-sm" v-on:click="onSave" v-if="hasRole(this.roles.RW_REG_TABDIGITATION)" v-show="!isCompleted"><i class="fa fa-check-circle"></i> {{$lang.Common.Buttons.Save}} </button>&nbsp;
          <button type="button" class="btn btn-default btn-sm text-secundary" v-on:click="onClear" v-if="hasRole(this.roles.RW_REG_TABDIGITATION)" v-show="!isCompleted"><i class="fa fa-minus-circle"></i> {{$lang.Common.Buttons.Clear}} </button>&nbsp;
        </div>
      </div>

    </Forms>
  </div>
</template>
<script>
import SinisterTyping from './sinistertyping.js'

export default SinisterTyping
</script>



// WEBPACK FOOTER //
// src/views/private/regulation/auto/typing/SinisterTyping.vue